import(/* webpackMode: "eager" */ "/app/src/app/[locale]/Education-Public/page.tsx");
